export default __webpack_public_path__ + "static/media/cybertruck.b011eb13.svg";